import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import {saveAs} from 'file-saver';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { Product } from 'src/app/models/contract-assignor';

@Component({
  selector: 'app-saldo-consolidado',
  templateUrl: './saldo-consolidado.component.html',
  styleUrls: ['./saldo-consolidado.component.css']
})
export class SaldoConsolidadoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private collaboratorsService: ColaboradorService,
    private modalService: NgbModal,
    private alertService: NewAlertService,
    private contractService: ContratoService,
    public datepipe: DatePipe
  ) { }

  public currentUser: Auth;
  public filtro = new FilterUseProducts(null,null,null,null,null,false);
  public produtos: any;  
  public assignorContractList: CedenteContrato[];
  productList: Product[];
  public productsCtrl: FormControl = new FormControl();

  public productsFilterText: string;
  public filtroOn: boolean = false;
  queryDate: Date;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.carregarRelatorio(1);
    this.getContracts();
  }

  carregarRelatorio(page){
    this.relatorioService.GetSummarizedBalance(this.currentUser.token.assignorGuid,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.produtos = response.result.detailedBalance;
        this.queryDate = response.result.queryDate;
      }
    });
  }

  getContracts(){
    this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.productList = response.result;
          if (this.productList.length <= 0 && this.productList.length <= 0) {
            this.alertService.error(response.message);
          }
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Erro ao carregar o filtro de produtos' + error);
      }
    );
  }
  
  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter() {
    this.productsFilterText = '';
    this.filtro.productsId = this.productsCtrl.value;
    
    this.filtro.productsId?.forEach((x, i)=> {
      this.productsFilterText += i==0 ?this.getProduct(x) : ', ' + this.getProduct(x);
    });

    if(
      this.filtro.productsId == null
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtro.productsId = null;
    this.productsCtrl.setValue(null);
    this.filtroOn = false;
    this.carregarRelatorio(1);
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_saldo_consolidado_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Produto','Valor'];
    ws.WorksheetRows = [];

    this.relatorioService.GetSummarizedBalance(this.currentUser.token.assignorGuid,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedBalance;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.product);
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = '';
        filter += this.filtro.productsId?.length > 0 ? 'Produtos: ' + this.productsFilterText : ''

        excelService.generateExcelReport('Saldo consolidado', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_saldo_consolidado_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Produto','Valor',''];
    pdfData.PdfRows = [];

    this.relatorioService.GetSummarizedBalance(this.currentUser.token.assignorGuid,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedBalance;

        result.forEach((r) => {
            const lr = new Array<string>();
            lr.push(r.product);
            lr.push('R$');
            lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            pdfData.PdfRows.push(lr);
        });

        let filter = '';
        filter += this.filtro.productsId?.length > 0 ? 'Produtos: ' + this.productsFilterText : ''

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Saldo consolidado',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  getProduct(item){
    return this.productList.find(x => x.produtoId == item).descricaoProduto;
  }
}

